import { render, staticRenderFns } from "./LeadBoardColumnRuleSidebar.vue?vue&type=template&id=3c786748&"
import script from "./LeadBoardColumnRuleSidebar.vue?vue&type=script&lang=js&"
export * from "./LeadBoardColumnRuleSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports